import { YaasPositionStatus } from "@solomon-apps/shared";
import { Button } from "@solomon-apps/shared/src/components/ui/button";
import React from "react";

import { ViewOnlyHint } from "@/components/ViewOnly";

export type EditPositionAction = "edit-rewards" | "resubmit";

interface ActionsRowProps {
    status: YaasPositionStatus;
    onAction: (action: EditPositionAction) => void;
    activeAction?: EditPositionAction;
    /**
     * Mobile view-only: disable the mutating actions and surface a
     * "switch to desktop" hint in their place.
     */
    viewOnly?: boolean;
}

export function ActionsRow({
    status,
    onAction,
    viewOnly = false
}: ActionsRowProps): React.ReactElement | null {
    // Only Rejected / Suspended positions have an action (Resubmit). Every
    // other status (Pending, Active, …) renders nothing — return `null`, not a
    // hidden div, so the editor's `gap-6` doesn't reserve an empty slot (which
    // would double-gap around it). Carries its own px so it aligns without a
    // wrapper. The Active edit-rewards trigger lives on the Rewards section.
    if (
        status === YaasPositionStatus.Rejected ||
        status === YaasPositionStatus.Suspended
    ) {
        return (
            <div
                aria-label="Available actions"
                className="px-4 md:px-6 flex flex-col items-start gap-2"
            >
                <Button
                    variant="raised"
                    size="md"
                    interaction="lifted"
                    disabled={viewOnly}
                    onClick={() => onAction("resubmit")}
                >
                    Resubmit for Review
                </Button>
                {viewOnly && <ViewOnlyHint />}
            </div>
        );
    }

    return null;
}
